module.exports = __webpack_public_path__ + "public/img/huiyuanxitong.965fe60d.png";